import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8741598c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "info_content" }
const _hoisted_2 = { class: "info_header fade-in" }
const _hoisted_3 = { class: "info_body" }
const _hoisted_4 = { class: "left" }
const _hoisted_5 = {
  id: "escape-path",
  class: "arrow-path",
  width: "49",
  height: "216",
  viewBox: "0 0 49 216",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_6 = { id: "escape-path-mask" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "0",
  y: "0",
  width: "49",
  height: "216",
  fill: "white"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "left_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "left_title_wrapper" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Important")
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "left_title_wrapper" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Notice")
  ])
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text_wrapper" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text_content" }, [
    /*#__PURE__*/_createTextVNode("This online experience is intended solely for users aged 13 or older. Any use by anyone under 13 is unauthorised and unlicensed. You certify that you are of the legal age of majority in the jurisdiction where you reside."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" The Escape Plan experience reflects guidance from, and has been approved by, the Federal Emergency Management Agency (FEMA). However it is in no way exhaustive guidance on everything to be aware of if a home fire occurs. Everyone’s circumstances in reality may differ."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" The provisions under “Limits on liability” in the "),
    /*#__PURE__*/_createElementVNode("a", {
      class: "link",
      href: "https://www.facebook.com/terms.php",
      rel: "noreferrer noopener",
      target: "_blank"
    }, "Meta Terms of Service"),
    /*#__PURE__*/_createTextVNode(" apply. Subject to those provisions, we are not responsible if information made available via the Escape Plan experience is not accurate, complete or current and it is provided for general information only, with any reliance upon that material being at your own risk."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" The Escape Plan online experience is a “Meta VR Product” and an “MPT Product” under the "),
    /*#__PURE__*/_createElementVNode("a", {
      class: "link",
      href: "https://www.meta.com/legal/quest/terms-of-service/",
      rel: "noreferrer noopener",
      target: "_blank"
    }, "Supplemental Meta Platform Technologies Terms of Service"),
    /*#__PURE__*/_createTextVNode(" and governed by those terms.")
  ])
], -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "text_button" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Agree and Continue")

import { ref, watch, nextTick, onUnmounted } from 'vue'
  import { useI18n } from 'vue-i18n'
  import SimpleScrollbar from 'simple-scrollbar'
  import 'simple-scrollbar/simple-scrollbar.css'
  
  import gsap from 'gsap'
  import { DrawSVGPlugin } from "gsap/DrawSVGPlugin"
  import { MotionPathPlugin } from "gsap/MotionPathPlugin";
  import { useAppState } from '@/services/composition'
  import { Role } from '@/services/states/AppStateMachine'

  import UIBrands from '@/components/UIBrands/UIBrands.vue'

  
export default /*#__PURE__*/_defineComponent({
  props: {
    infoOptions: Object,
    isAnimationBlocked: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {

const props = __props

  gsap.registerPlugin(DrawSVGPlugin);
  gsap.registerPlugin(MotionPathPlugin);

  const handleScroll = (e: any) => {
    if (enableButton.value) return
    const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    if (bottom) {
      enableButton.value = true
      const scrollContainer = scroller.value.querySelector('.ss-content');
      scrollContainer.removeEventListener('scroll', handleScroll)
    }
  }

  const { t } = useI18n()
  const { state } = useAppState()

  const root = ref<HTMLElement>(null)
  const container = ref<HTMLElement>(null)
  const scroller = ref<HTMLElement>(null)
  const enableButton = ref(false)
  const noScrollBar = ref(false)

  const escapePathMask = ref(null)
  const escapePathHead = ref(null)
  const escapePathLine = ref(null)
  const escapePathData = ref({
  })

  

  // onMounted(() => {
  //   if (scroller.value) {
  //     // SimpleScrollbar.unbindEl(scroller.value) 
  //     SimpleScrollbar.initEl(scroller.value)
  //   }
  // })

  watch( () => props.infoOptions, async ({ isOpen }) => {
    await nextTick()
    if(isOpen && scroller.value) {
      SimpleScrollbar.initEl(scroller.value)
      const scrollWidth = getScrollWidth()
      const scrollContainer = scroller.value.querySelector('.ss-content') as HTMLElement;
      const bottom = scrollContainer.scrollHeight - scrollContainer.scrollTop === scrollContainer.clientHeight;
      if (bottom) {
        enableButton.value = true
      } else {
        scrollContainer.addEventListener('scroll', handleScroll)
      }
      if (scrollWidth === 0) {
        scrollContainer.style.width = '100%';
        noScrollBar.value = true;
      }
      setInitialPosition()
    }
  }, { deep: true })
  onUnmounted(() => {
    if(props.infoOptions.isOpen && scroller.value) {
      const scrollContainer = scroller.value.querySelector('.ss-content');
      scrollContainer.removeEventListener('scroll', handleScroll)
    }
  })

  const getScrollWidth = () => {
    var outer = document.createElement('div');
    var inner = document.createElement('div');
    outer.style.width = inner.style.width = '100%';
    outer.style.overflow = 'scroll';
    document.body.appendChild(outer).appendChild(inner);
    var scroll_width = outer.offsetWidth-inner.offsetWidth;
    outer.parentNode.removeChild(outer);
    return scroll_width;
  }

  const setInitialPosition = () => {
    if(state.value.context.role == Role.Desktop && window.innerWidth > 1350) {
      container.value.style.transformOrigin = 'bottom right'
        const { width, height } = container.value.getBoundingClientRect()
        container.value.style.transform =  `translate()`
        container.value.style.setProperty(
          'transform', `translate(
            ${props.infoOptions.x - (width / 2)}px,
            ${props.infoOptions.y - (height / 2)}px
          )`
        )
    } else {
      root.value.style.justifyContent = 'center'
      root.value.style.alignItems = 'center'
    }
  }

  const onEnter = (el: gsap.DOMTarget, onComplete: gsap.Callback) => {
    const isDesktop = state.value.context.role == Role.Desktop  
  
    const $ = gsap.utils.selector(el)
    const path = (escapePathMask.value as SVGPathElement)
    const head = (escapePathHead.value as SVGGElement)

    gsap.set($('#escape-path'), { opacity: 0 })

    const tl = gsap.timeline({ onComplete }).addLabel('escapePath', 0.1)
    tl.fromTo(el, {
      opacity: 0,
    },{
      opacity: 1,
      duration: 0.5,
      ease: "power2.in"
    }, 'start')
    tl.fromTo($('.info_content'), {
      y: 100      
    }, {
      y: 0,
      duration: 1,
      ease: "power1"
    }, 'start')

    if(isDesktop) {
      tl.to($('#escape-path'), {
        opacity: 1,
        duration: 0.8,
        ease: 'power2.inOut'
      }, "escapePath")
      tl.fromTo(path, {
        drawSVG: '0 100%'
      }, {
        drawSVG: '100% 100%',
        duration: 1.2,
        ease: 'quart.inOut'
      }, "escapePath")
      tl.to(head, {
        motionPath: {
          path: path, 
          autoRotate: true,
          align: path,
          alignOrigin: [0.5, 0.5]
        },
        duration: 1.2,
        ease: 'quart.inOut'
      },"escapePath")
    }

    tl.fromTo($('.left_title_wrapper span'), {
      y: 70,
    }, {
      y: 0,
      duration: 0.5,
      ease: "quart.out",
      stagger: isDesktop && 0.1
    }, isDesktop ? "escapePath+=0.6": 0.6)

    tl.fromTo($('.fade-in'), {
      opacity: 0,
    }, {
      opacity: 1,
      duration: 0.6,
      ease: "power2.inOut"
    }, isDesktop ? "escapePath+=0.8": 0.8)
  }

  const onLeave = (el: gsap.DOMTarget, onComplete: gsap.Callback) => {
    gsap.to(el, {
      opacity: 0,
      duration: 0.3,
      ease: "power2.out",
      onComplete
    })
  }


return (_ctx: any,_cache: any) => {
  const _component_ui_icon = _resolveComponent("ui-icon")!
  const _component_ui_btn = _resolveComponent("ui-btn")!

  return (_openBlock(), _createBlock(_Transition, {
    css: false,
    onEnter: onEnter,
    onLeave: onLeave
  }, {
    default: _withCtx(() => [
      (props.infoOptions.isOpen)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            ref_key: "root",
            ref: root,
            class: "info"
          }, [
            _createElementVNode("div", {
              ref_key: "container",
              ref: container,
              class: "info_inner"
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_ui_icon, {
                    class: "logo",
                    name: "logo-brand"
                  })
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    (_openBlock(), _createElementBlock("svg", _hoisted_5, [
                      _createElementVNode("defs", null, [
                        _createElementVNode("mask", _hoisted_6, [
                          _hoisted_7,
                          _createElementVNode("path", {
                            ref_key: "escapePathMask",
                            ref: escapePathMask,
                            d: "M10 216L10 8L34 8.00003",
                            fill: "none",
                            stroke: "black",
                            "stroke-width": "4"
                          }, null, 512)
                        ])
                      ]),
                      _createElementVNode("path", {
                        ref_key: "escapePathHead",
                        ref: escapePathHead,
                        d: "M44 8.12728L34 1L34 15L44 8.12728Z",
                        fill: "#1A1A1A"
                      }, null, 512),
                      _createElementVNode("path", {
                        ref_key: "escapePathLine",
                        ref: escapePathLine,
                        mask: "url(#escape-path-mask)",
                        d: "M10 216L10 8L34 8.00003",
                        fill: "none",
                        stroke: "#1A1A1A",
                        "stroke-width": "2",
                        "stroke-linejoin": "bevel",
                        "stroke-dasharray": "8 16"
                      }, null, 512)
                    ])),
                    _hoisted_8
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["text fade-in", { noScrollBar: noScrollBar.value }])
                  }, [
                    _createElementVNode("div", {
                      ref_key: "scroller",
                      ref: scroller,
                      class: "text_inner"
                    }, _hoisted_10, 512),
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_ui_btn, {
                        disabled: !enableButton.value,
                        variant: "secondary",
                        color: "dark",
                        "border-position": "top-left",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeInfo')))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_12
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ])
                  ], 2)
                ])
              ])
            ], 512)
          ], 512))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})